import { StyleSheet } from 'react-native';

const arrivedColor = '#ddd'; 
const preludeCoverColor = '#666';
const overtureCoverColor = '#666';
const seekingColor = '#666'; 

const styles = StyleSheet.create({
  captionText: {
    fontFamily: 'CenturyGothic',
    fontSize: 28,
    fontWeight: 'bold',
    lineHeight: 40
  },

  installationText: {
    fontFamily: 'CenturyGothic',
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: 36
  },

  screenHeadingWithBackground: {
    justifyContent: "center", 
    alignItems: "center", 
    width: "100%", 
    marginBottom: 20, 
    marginTop: 0,
    padding: 5,
    paddingBottom: 10,
    paddingTop: 10,
    backgroundColor: '#5558',    
  },

  headingText: {
    color: '#eee',
    fontSize: 26,
    fontWeight: 'bold',
    fontFamily: 'CenturyGothic'
  },

  heroGPS: {
    alignItems: 'center', 
    backgroundColor: '#eeeeee', 
    padding: 20, 
    marginBottom: 20, 
    borderRadius: 20
  },

  heroGPSText: {
    fontSize: 36, 
    fontWeight: 'bold',
    fontFamily: 'CenturyGothic',
  },

  sectionHeadingText: {
    fontSize: 22,
    fontWeight: 'bold',
    fontFamily: 'CenturyGothic',
  },

  sectionContentText: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: 'CenturyGothic',
  }, 

  locScreenFrame: {
    flexDirection: "column",
    paddingTop: 18,
  },

  /* *** TabBar *** */

  tabbar: {
    height: 60, 
    flexDirection: 'row', 
    backgroundColor: 'white',
  },

  tabBarItem: {
    flex: 1, 
    justifyContent: 'center', 
    alignItems: 'center', 
    padding: 10
  },

  tabBarItemText: {
    textAlign: 'center',
    fontFamily: "CenturyGothic", 
    fontWeight: 'bold' 
  },

  /* *** LISTINGS *** */

  li_title: {
    fontStyle: 'italic',
    fontSize: 16,
    fontFamily: "CenturyGothic",
  },

  li_artist: {
    fontSize: 16,
    fontFamily: "CenturyGothic"
  },

  li_location: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#43B02A',
    fontFamily: "CenturyGothic"
  },

  li_theme: {
    fontSize: 16,
    fontFamily: 'CenturyGothic'
  },

  li_directions: {
    fontWeight: 'bold',
    fontSize: 24,
    fontFamily: "CenturyGothic",
    textAlign: 'right',
    color: '#43B02A'
  },

  li_subright: {
    fontSize: 16,
    fontFamily: "CenturyGothic",
    textAlign: 'right'
  },

  searchField: {
    flex: 1,
    padding: 8,
    borderRadius: 10,
    backgroundColor: '#eee',
    fontSize: 18,
    fontFamily: "CenturyGothic",
  },

  feedbackField: {
    fontSize: 18,
    borderRadius: 20,
    borderColor: '#333',
    backgroundColor: '#efefef',
    padding: 20,
    borderWidth: 1,
    width: '100%',
    marginVertical: 5,
    flex: 1
  },
  
  /* *** BUTTONS *** */

  smallButton: {
    backgroundColor:'#445079',
    justifyContent: 'center',
    padding: 5,
    flexDirection: 'column',
    margin: 5,
    width: 250,
    borderRadius: 10
  },

  smallButtonText: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: "CenturyGothic"
  },

  smallGreyButton: {
    borderRadius: 10,
    backgroundColor:'#777',
    justifyContent: 'center',
    padding: 10,
    fontSize: 16,
    fontWeight: 'light'
  },

  smallGreyButtonText: {
    color: 'white',
    fontWeight: 'regular'
  },

  smallerButton: {
    backgroundColor:'#445079',
    justifyContent: 'center',
    padding: 4,
    flexDirection: 'column',
    margin: 5,
    width: 150
  },


  restartButton: {
    backgroundColor: '#a00',
    justifyContent: 'center',
    padding: 10,
    flexDirection: 'column',
    margin: 5,
    width: 250,
    borderRadius: 20
  },

  doneButton: {
    backgroundColor: '#d3a652',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    paddingLeft: 40,
    paddingRight: 40,
    marginBottom: 0
  },

  smallCloseButton: {
    backgroundColor: '#d3a652',
    justifyContent: 'center',
    padding: 5,
    flexDirection: 'column',
    margin: 5,
    width: 250,
    borderRadius: 10
  },


  /* *** HELP / INFO PANEL *** */

  panelFrame: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'flex-start'
  },

  helpText: {
    textAlign: 'center',
    fontSize: 18,
    marginBottom: 18,
    padding: 5,
    fontFamily: "CenturyGothic"
  },
  helpTextLarge: {
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 18,
    padding: 8,
    fontFamily: "CenturyGothic"
  },

  creditsText: {
    textAlign: 'center',
    fontSize: 18,
    fontFamily: "CenturyGothic"
  },

  infoText: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 10,
    fontFamily: "CenturyGothic"
  },
  infoSection: {
    alignItems: 'center',
    margin: 10
  },

  startVoyageCover: {
    backgroundColor: '#234623',
    justifyContent: 'center',
    flexDirection: 'row',
  },

  startVoyageCoverDark: {
    backgroundColor: '#234623',
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 20,
    borderRadius: 10,
  },


  /* *** Markdown Box *** */

  markdownTitle: {
    fontWeight: 'bold', 
    fontSize: 24,
    fontFamily: "CenturyGothic" 
  },

  markdownBody: {
    fontSize: 22, 
    lineHeight: 30,
    fontFamily: "CenturyGothic" 
  },

  markdownBodyLarge: {
    fontSize: 28, 
    lineHeight: 32,
    fontFamily: "CenturyGothic" 
  },

  markdownScrollFrame: {
    backgroundColor: '#ddd',
    padding: 5
  },

  contentItemFrame: {
    borderRadius: 20,
    margin: 5,
    marginTop: 10,
    marginBottom: 15,
    justifyContent: 'center',
    backgroundColor: 'white',
    opacity: 0.85,
    minHeight: 150,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },

  contentItemFrameSingle: {
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#eee',
    opacity: 0.9,
    minHeight: 400,
    borderWidth: 3,
    margin: 10,
    marginTop: 40,
    marginBottom: 40,
    borderColor: '#aaa',
    padding: 10
  },

  captionbox: {
    borderRadius: 20,
    justifyContent: "flex-start",
    borderWidth: 2,
    borderColor: '#777',
    padding: 10
  },

  contentItemCover: {
    borderRadius: 20,
    backgroundColor: seekingColor,
    opacity: 0.85,
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 5,
    marginBottom: 15,
  },

  captionCover: {
    borderRadius: 20,
    backgroundColor: arrivedColor,
    opacity: 0.8,
    justifyContent: 'center',
    flexDirection: 'row',
  },

  preludeCover: {
    borderRadius: 20,
    margin: 5,
    marginBottom: 15,
    backgroundColor: preludeCoverColor,
    justifyContent: 'center',
    flexDirection: 'row',
  },

  overtureCover: {
    borderRadius: 20,
    margin: 5,
    marginBottom: 15,
    backgroundColor: overtureCoverColor,
    justifyContent: 'center',
    flexDirection: 'row',
  },

  contentItemCoverText: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 26,
    fontFamily: "CenturyGothic"
  },

  contentItemText: {
    fontSize: 22,
    color: '#444',
    fontWeight: 'bold',
    textAlign: 'center',
    fontFamily: "CenturyGothic"
  },

  singleItemText: {
    fontSize: 24,
    textAlign: 'center',
    fontWeight: 'bold',
    padding: 20,
    fontFamily: "CenturyGothic"
  },

  preludeItemText: {
    fontSize: 14,
    textAlign: 'center',
    color: '#333',
    fontFamily: "CenturyGothic"
  },

});

export default styles;


export function resizeFont(fontSpec, useLargerFonts) {  
  if (useLargerFonts === true) {
    if (!!(fontSpec.fontSize)) {
      const newSize = fontSpec.fontSize * 1.33;
      return {...fontSpec, fontSize: newSize}
    } else {
      return fontSpec;
    }
  } else {
    return fontSpec;
  }
}
